"use client";
import React from "react";
import { Box } from "@mui/material";
import Image from "next/image";
import LogoLoader from "../../../assets/salontym_loder.png";
import LinearProgress from "@mui/material/LinearProgress";
import "./index.css";

export const MainLoader = () => {
  // const [progress, setProgress] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(false);
    // const timer = setInterval(() => {
    //   setProgress((prevProgress) => {
    //     const newProgress = prevProgress + 1;
    //     if (newProgress >= 100) {
    //       clearInterval(timer);
    //       setLoading(false);
    //       return 100;
    //     }
    //     return newProgress;
    //   });
    // }, 100);
    // return () => {
    //   clearInterval(timer);
    // };
  }, []);

  return (
    <Box
      style={{
        display: loading ? "block" : "none",
        position: "fixed",
        zIndex: 10000,
        height: "100%",
        width: "100%",
        background: "#f2efef",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: "auto",
          textAlign: "center",
          width: "20%",
        }}
      >
        <Image
          src={LogoLoader}
          priority={true}
          alt="Logo"
          style={{
            width: "80px",
            paddingBottom: "16px",
            margin: "auto",
            height: "auto",
          }}
          height={200}
          width={200}
          className="loader-image"
        />
        <Box sx={{ width: "100%", margin: "auto" }}>
          <LinearProgress
            color="success"
            // variant="determinate"
            // value={progress}
          />
        </Box>
      </Box>
    </Box>
  );
};
